import React from "react";
import { Dropdown } from "primereact/dropdown";

const RESERVABLE_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const ReservableFilter: React.FC<{
  value: boolean | null;
  filterCallback: (value: boolean | null, index: number) => void;
}> = ({ value, filterCallback }) => (
  <Dropdown
    value={value}
    options={RESERVABLE_OPTIONS}
    onChange={(e) => filterCallback(e.value, 0)}
    placeholder="Select"
    className="p-column-filter"
    showClear
  />
);
